import { render, staticRenderFns } from "./PermitCancel.vue?vue&type=template&id=298df181&scoped=true&"
import script from "./PermitCancel.vue?vue&type=script&lang=js&"
export * from "./PermitCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298df181",
  null
  
)

export default component.exports